import { Box, Grid, Theme, Typography } from "@mui/material";
import { ViewProfileProps } from "../types";
import { KeyValue } from "../../ApplicationDetails/personalDetails";
import React, { useEffect, useState } from "react";
import { SubHeading } from "../../investors/components";
import { getBankAddress } from "../../../utils/utilityFunctions";
import { useDispatch } from "react-redux";
import { BankSubAccountTypesObj, GetBankSubAccountTypesResponseBody } from "../../../redux-store/types/api-types";
import { getBankSubAccountTypes } from "../../../redux-store/actions/application";

export default function BankDetails({ overviewData }: { overviewData: Partial<ViewProfileProps> }): JSX.Element {
    const dispatch = useDispatch()

    const { banks } = overviewData;

    const [bankSubAccTypesArr, setBankSubAccTypesArr] = useState<Array<BankSubAccountTypesObj>>([])

    useEffect(() => {
        (async function () {
            try {
                if (overviewData) {
                    // Getting status of first applicant (Individual/NRE/NRO)
                    const currentStatus = (overviewData?.applicants ?? []).find(obj => obj.applicant_type === "1")?.status ?? ""

                    // Getting Account Type (EXE/POA/ADVISORY/HLDAWY)
                    const currentAccountType = overviewData?.accountType ?? ""

                    const response = await (dispatch(getBankSubAccountTypes({
                        status: currentStatus ?? "",
                        accountType: currentAccountType ?? ""
                    })) as unknown as Promise<GetBankSubAccountTypesResponseBody>)

                    if (response) {
                        setBankSubAccTypesArr(response?.bankSubAccountTypes ?? [])
                    }
                }
            } catch (e) {
                console.log((e as Error).message);
            }
        })();
    }, [overviewData]);

    return (
        <>
            <Box
                sx={(theme: Theme) => ({
                    bgcolor: 'white',
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                    borderRadius: '10px',
                    border: `1px solid ${theme.palette.grey[100]}`,
                    padding: '25px',
                    mb: '40px'
                })}
            >
                <Box>
                    <Grid container >
                        <Typography variant='h2' sx={(theme: Theme) => ({ fontSize: 18, fontWeight: 700, color: theme.palette.primary[900], mb: '9px' })}>
                            Investor&apos;s Bank Details
                        </Typography>
                        {banks?.length === 0 ? (
                            <Grid
                                xs={12}
                                sm={12}
                                sx={{
                                    fontSize: 16,
                                    fontWeight: 600,
                                    color: 'text.primary',
                                    textAlign: 'center',
                                    my: 1.5,
                                }}>
                                No Bank Details
                            </Grid>
                        ) : (
                            banks?.map((bank, index: number) => {
                                const title = ['Bank 1 Details', 'Bank 2 Details', 'Bank 3 Details'][index];
                                const bankAddress = getBankAddress(bank.address1, bank.address2, bank.address3);

                                const currentBankSubAccType = (bankSubAccTypesArr ?? [])?.find((obj: BankSubAccountTypesObj) => `${obj?.code ?? ""}`.toLowerCase() === `${bank?.bankSubAccType ?? ""}`.toLowerCase())?.description ?? (bank?.bankSubAccType ?? "")

                                return (
                                    <React.Fragment key={bank.id}>
                                        <SubHeading sx={{ letterSpacing: "0.02px" }}>{title}</SubHeading>

                                        <Grid
                                            item
                                            container

                                            rowSpacing={3}
                                            columnSpacing={5.5}
                                            direction="row"

                                        >
                                            <KeyValue title={'IFSC Code'} description={bank.ifscCode} />
                                            <KeyValue
                                                title={'Bank Account Number'}
                                                description={bank.bankAccountNumber}
                                            />
                                            <KeyValue title={'MICR Code'} description={bank.micrCode} />
                                            <KeyValue title={'Bank Account Type'} description={bank.bankAccountType} />
                                            <KeyValue title={'Bank Sub Account Type'} description={currentBankSubAccType} />
                                            <KeyValue title={'Bank Name'} description={bank.bankName} />
                                            <KeyValue title={'Branch Name'} description={bank.bankBranch} />
                                            <KeyValue
                                                title={`Bank Address`}
                                                description={`${bankAddress}`}
                                                sx={{
                                                    textTransform: 'capitalize',
                                                }}
                                            />
                                            <KeyValue
                                                title={`Default Bank Account`}
                                                description={bank.defaultBankAccount ? 'Yes' : '-'}
                                            />
                                        </Grid>

                                    </React.Fragment>
                                );
                            })
                        )}
                    </Grid>
                </Box>
            </Box >
        </>
    );
}
